import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import LayoutContext from 'components/UI/Layout/LayoutContext';
import clsx from 'clsx';

function Container({
    children, className, spacing, style, vSpacing,
})
{
    const classes = clsx({
        [className]: Boolean(className),
    });

    const containerValue = useMemo(() => ({
        spacing,
        vSpacing,
    }), []);

    return (
        <LayoutContext.Provider
            value={containerValue}
        >
            <div className={classes} style={style}>
                {children}
            </div>
        </LayoutContext.Provider>

    );
}

Container.displayName = 'Container';

Container.defaultProps = {
    spacing: 1,
    style: {},
    vSpacing: false,
};

Container.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    spacing: PropTypes.number,
    style: PropTypes.object,
    vSpacing: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default Container;
